module.exports = __webpack_public_path__ + "img/how-one.98c6a5e2.svg";